import toast from 'react-hot-toast';

export const handleImprimirSolicitud = (solicitud) => {
  const printWindow = window.open('', '_blank', 'width=800,height=900');
  if (!printWindow) {
    toast.error('El navegador bloqueó la ventana emergente para imprimir.');
    return;
  }

  const itemsRows = (solicitud.items || []).map(item => {
    let registroHtml = item.registro || '-';
    if (item.registro_indice) {
      const intervinientes = item.registro_indice.intervinientes && item.registro_indice.intervinientes.length > 0 
        ? item.registro_indice.intervinientes.map(inv => [inv.nombres, inv.apellido_paterno, inv.apellido_materno].filter(Boolean).join(' ')).join(' / ')
        : 'Sin intervinientes';
      
      registroHtml = `
        <div style="font-size: 11px; margin-bottom: 2px;"><strong>${item.registro_indice.tipo_registro || item.registro || ''}</strong></div>
        <div style="font-size: 11px; color: #475569; margin-bottom: 2px;">F: ${item.registro_indice.foja || '-'} | N: ${item.registro_indice.numero || '-'} | A: ${item.registro_indice.anio || '-'}</div>
        <div style="font-size: 11px; color: #64748b;"><em>${intervinientes}</em></div>
      `;
    }

    return `
    <tr>
      <td style="padding: 12px; border-bottom: 1px solid #e2e8f0; font-weight: 500; color: #1e293b; max-width: 250px;">
        ${item.tipo_documento || '-'}
      </td>
      <td style="padding: 12px; border-bottom: 1px solid #e2e8f0; color: #475569; white-space: nowrap;">
        ${item.foja || '-'}/${item.numero || '-'}/${item.anio || '-'}
      </td>
      <td style="padding: 12px; border-bottom: 1px solid #e2e8f0; color: #475569;">
        ${registroHtml}
      </td>
    </tr>
    `;
  }).join('');

  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Solicitud ${solicitud.numero_seguimiento || ''}</title>
        <style>
          body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            color: #0f172a;
            margin: 0;
            padding: 40px;
            background: #fff;
            line-height: 1.5;
          }
          .header {
            text-align: center;
            margin-bottom: 40px;
            border-bottom: 2px solid #0f172a;
            padding-bottom: 20px;
          }
          .title {
            font-size: 24px;
            font-weight: 800;
            margin: 0 0 5px 0;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          .subtitle {
            font-size: 14px;
            color: #64748b;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .section-title {
            font-size: 14px;
            font-weight: 700;
            color: #0f172a;
            text-transform: uppercase;
            margin-bottom: 15px;
            border-bottom: 1px solid #e2e8f0;
            padding-bottom: 8px;
          }
          .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
            margin-bottom: 40px;
            background: #f8fafc;
            padding: 20px;
            border-radius: 8px;
          }
          .info-item {
            margin-bottom: 5px;
          }
          .info-label {
            font-size: 12px;
            color: #64748b;
            font-weight: 600;
            text-transform: uppercase;
          }
          .info-value {
            font-size: 15px;
            font-weight: 500;
            color: #1e293b;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 40px;
          }
          th {
            text-align: left;
            padding: 12px;
            background: #0f172a;
            color: #fff;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .footer {
            text-align: center;
            font-size: 12px;
            color: #94a3b8;
            margin-top: 50px;
            border-top: 1px solid #e2e8f0;
            padding-top: 20px;
          }
          @media print {
            body { padding: 0; }
            .info-grid { background: #fff !important; border: 1px solid #e2e8f0; }
            th { background: #e2e8f0 !important; color: #0f172a !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1 class="title">Conservador de Bienes Raíces</h1>
          <div class="subtitle">San Carlos</div>
        </div>
        
        <div class="info-grid">
          <div>
            <div class="info-item"><div class="info-label">N° de Seguimiento</div><div class="info-value">${solicitud.numero_seguimiento || '-'}</div></div>
            <div class="info-item" style="margin-top:15px"><div class="info-label">Fecha de Ingreso</div><div class="info-value">${new Date(solicitud.created_at).toLocaleDateString('es-CL')}</div></div>
            <div class="info-item" style="margin-top:15px"><div class="info-label">Forma de Entrega</div><div class="info-value">${solicitud.forma_entrega || '-'}</div></div>
          </div>
          <div>
            <div class="info-item"><div class="info-label">Solicitante</div><div class="info-value">${solicitud.nombre_solicitante || '-'}</div></div>
            <div class="info-item" style="margin-top:15px"><div class="info-label">RUT</div><div class="info-value">${solicitud.rut_solicitante || '-'}</div></div>
            <div class="info-item" style="margin-top:15px"><div class="info-label">Email</div><div class="info-value">${solicitud.email || '-'}</div></div>
            <div class="info-item" style="margin-top:15px"><div class="info-label">RUT Boleta</div><div class="info-value">${solicitud.rut_boleta || solicitud.rut_solicitante || '-'}</div></div>
            ${solicitud.boleta_razon_social ? `<div class="info-item" style="margin-top:15px"><div class="info-label">Razón Social Boleta</div><div class="info-value">${solicitud.boleta_razon_social}</div></div>` : ''}
            ${solicitud.boleta_giro ? `<div class="info-item" style="margin-top:15px"><div class="info-label">Giro Comercial</div><div class="info-value">${solicitud.boleta_giro}</div></div>` : ''}
            ${solicitud.boleta_correo ? `<div class="info-item" style="margin-top:15px"><div class="info-label">Correo Facturación</div><div class="info-value">${solicitud.boleta_correo}</div></div>` : ''}
            ${solicitud.boleta_direccion ? `<div class="info-item" style="margin-top:15px"><div class="info-label">Dirección Tributaria</div><div class="info-value">${solicitud.boleta_direccion}</div></div>` : ''}
          </div>
        </div>

        <div class="section-title">Documentos Solicitados</div>
        <table>
          <thead>
            <tr>
              <th>Documento</th>
              <th>F/N/A</th>
              <th>Registro</th>
            </tr>
          </thead>
          <tbody>
            ${itemsRows}
          </tbody>
        </table>

        ${solicitud.observaciones ? `
          <div class="section-title">Observaciones</div>
          <p style="font-size: 14px; color: #475569;">${solicitud.observaciones}</p>
        ` : ''}

        <div class="footer">
          Documento generado el ${new Date().toLocaleString('es-CL')}
        </div>
        
        <script>
          window.onload = function() {
            window.print();
            setTimeout(function() { window.close(); }, 500);
          };
        </script>
      </body>
    </html>
  `;
  
  printWindow.document.write(html);
  printWindow.document.close();
};
